module.exports = __webpack_public_path__ + "static/media/drivers-license-front-sample.fb3d0f44.svg";